import { Provider } from '@angular/core';
import { PunchoutProtocolHandler } from '../services/punchout/handlers/punchout-protocol.handler';
import { RuntimeProtocolDelegate } from '../services/punchout/handlers/runtime-protocol-delegate';
import { PunchoutCurrentConfigService } from '../services/punchout/punchout-current-config.service';
import { PUNCHOUT_HANDLER, PUNCHOUT_PROTOCOL_HANDLERS } from '../services/punchout/punchout.tokens';

export function punchoutHandlerFactory(
  handlers: PunchoutProtocolHandler[],
  currentConfigService: PunchoutCurrentConfigService
): PunchoutProtocolHandler {
  return new RuntimeProtocolDelegate(handlers, currentConfigService);
}

export const punchoutHandlerProvider: Provider = {
  provide: PUNCHOUT_HANDLER,
  useFactory: punchoutHandlerFactory,
  deps: [PUNCHOUT_PROTOCOL_HANDLERS, PunchoutCurrentConfigService]
};
